import { render, staticRenderFns } from "./modalFreightBuilder.vue?vue&type=template&id=cca7ed4e&scoped=true"
import script from "./modalFreightBuilder.vue?vue&type=script&lang=js"
export * from "./modalFreightBuilder.vue?vue&type=script&lang=js"
import style0 from "./modalFreightBuilder.vue?vue&type=style&index=0&id=cca7ed4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca7ed4e",
  null
  
)

export default component.exports